import { WeightType, type AwardCriterionDto, type AwardCriterionWeightDto } from "../../autogen/bff-api";
import { ENVIRONMENTAL_AWARD_CRITERION_TYPES, isExemptionMarker } from "../procurement/publicProcurementOptions";

// LOA § 5b third sentence: criteria stated in order of priority put climate and environment among the three highest.
export const HIGHEST_PRIORITIES_THAT_MEET_CLIMATE_RULE = 3;

export const isPriority = (weight: AwardCriterionWeightDto | null | undefined): boolean =>
  weight?.type === WeightType.OrderOfImportance;

export const percentWeight = (weight: AwardCriterionWeightDto | null | undefined): number | null =>
  weight == null || isPriority(weight) ? null : weight.number;

export const areInOrderOfPriority = (criteria: readonly AwardCriterionDto[]): boolean =>
  criteria.some((criterion) => isPriority(criterion.weight)) &&
  !criteria.some((criterion) => criterion.weight?.type === WeightType.Percentage);

export const withPriorityNumbers = (criteria: readonly AwardCriterionDto[]): AwardCriterionDto[] => {
  let rank = 0;
  return criteria.map((criterion) =>
    isExemptionMarker(criterion.type)
      ? criterion
      : { ...criterion, weight: { number: ++rank, type: WeightType.OrderOfImportance } },
  );
};

export const withoutWeights = (criteria: readonly AwardCriterionDto[]): AwardCriterionDto[] =>
  criteria.map((criterion) => ({ ...criterion, weight: undefined }));

export const highestEnvironmentPriority = (criteria: readonly AwardCriterionDto[]): number | null => {
  const index = criteria
    .filter((criterion) => !isExemptionMarker(criterion.type))
    .findIndex((criterion) => ENVIRONMENTAL_AWARD_CRITERION_TYPES.includes(criterion.type));
  return index < 0 ? null : index + 1;
};

export const climateAmongHighestPriorities = (criteria: readonly AwardCriterionDto[]): boolean => {
  const priority = highestEnvironmentPriority(criteria);
  return priority != null && priority <= HIGHEST_PRIORITIES_THAT_MEET_CLIMATE_RULE;
};

export const moveCriterion = (
  criteria: readonly AwardCriterionDto[],
  index: number,
  direction: -1 | 1,
): AwardCriterionDto[] => {
  const target = index + direction;
  if (target < 0 || target >= criteria.length) return [...criteria];
  const moved = [...criteria];
  [moved[index], moved[target]] = [moved[target], moved[index]];
  return areInOrderOfPriority(moved) ? withPriorityNumbers(moved) : moved;
};
